import React from "react";

import DOMPurify from "dompurify";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export const CreateNewOportunityModal = ({ open, onClose, oportunity }) => {
  const handleClose = () => {
    onClose();
  };

  const sanitizeHtml = (html) => {
    const safeHtml = DOMPurify.sanitize(html);

    return <div dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "700px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">Oportunidade</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            width: "100%",
            minWidth: "300px",
            padding: "20px",
          }}
        >
          <div>
            <span
              style={{ fontWeight: "bold" }}
            >{`Cargo/função: ${oportunity.cargo}`}</span>
          </div>
          {oportunity.local ? (
            <div>
              <span
                style={{ fontWeight: "bold" }}
              >{`Local: ${oportunity.local}`}</span>
            </div>
          ) : (
            <></>
          )}
          <div>
            <span style={{ fontWeight: "bold" }}>{`Remuneração: ${
              oportunity.remuneracao > 0 ? oportunity.remuneracao : "A combinar"
            }`}</span>
          </div>
          <div>
            <span
              style={{ fontWeight: "bold" }}
            >{`Empresa: ${oportunity.empresa}`}</span>
          </div>
          <div>
            <span
              style={{ fontWeight: "bold" }}
            >{`Tipo de vínculo: ${oportunity.vinculo}`}</span>
          </div>
          <div>
            <span
              style={{ fontWeight: "bold" }}
            >{`Regime de trabalho: ${oportunity.regime}`}</span>
          </div>
          <div
            style={{
              marginTop: "50px",
              whiteSpace: "pre-wrap",
              textAlign: "justify",
            }}
          >
            {sanitizeHtml(oportunity.descricao)}
          </div>
          <div style={{ marginTop: "20px" }}>
            <div style={{ marginBottom: "5px" }}>
              <span>Tecnologias:</span>
            </div>
            <p>{oportunity.skills.join(", ")}</p>
          </div>
        </div>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
